<template>
  <router-view style="width: 100%; height: 100%;" />
</template>

<script>
export default {
  name: 'IndexView'
}
</script>
